var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"./aru"}},[_vm._v("Home")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"./project"}},[_vm._v("About")])],1),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }